import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

export const BUTTON = cxs({
  color: COLOURS.grey.regent,
  minHeight: '85px'
});

export const ICON_CONTAINER = cxs({
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'center',

  ' > p': {
    marginBottom: 0,
    marginTop: '5px'
  }
});

export const ICON = cxs({
  cursor: 'pointer',
  position: 'relative',
  width: '50px',
  minWidth: '50px !important',
  minHeight: '50px !important',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',

  ' > span': {
    position: 'relative',
    zIndex: 1
  },

  ':hover': {
    background: COLOURS.grey.catSkillWhite
  }
});